export default {
	"order.DontLeaveTheSystemIsGettingThePaymentResult": "请勿离开，系统正在获取支付结果~",
	"order.DoNotLeaveTheSystemIsGettingThePaymentResultTheTerminationProcessMayAffectTheContentArrival": "请勿离开，系统正在获取支付结果,终止流程可能影响内容到账~",
	"order.SuccessfullyPaidJumpingIn": "已支付成功，正在跳转中...",
	"order.SorryFailedToInitiatePayment": "抱歉，发起支付失败！",
	"order.PaymentFailed": "支付失败!",
	"order.paymentSuccessful": "支付成功",
	"order.TheSystemIsTryingToGetThePaymentResultInformationCheckThePaymentDetailsAndTry": "系统正在努力获取支付结果信息，查看支付详情试试。",
	"order.ParameterError": "参数错误!",
	"order.AfterThePaymentIsSuccessfulTheVirtualGoodsInTheOrderNeedToBeActivatedBeforeTheyCanBeUsed": "支付成功后，订单中含有虚拟商品需要激活才能使用哦",
	"order.CallingRequiresYourWeChatAuthorizationInOrderToAddExperienceContentToYourAccount": "叫叫需要您的微信授权，以便给您的账户下添加体验内容",
	"order.DoNotLeave": "请勿离开!",
	"order.retryNow": "立即重试"
}